import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import {
  LOCALE_CODE_LIST,
  Language,
  NOT_AVAILABLE,
  TIME_12HOUR_FORMAT,
  TIME_SHORT_FORMAT,
  LOCALE_SHORT_DISPLAY_DATE_FORMAT,
} from '../../common/constants';
import { getTimezoneOffsetInHours, getTimestampWithTimezoneOffset } from '../../common/utils';
import { AppFacade } from '../../store/state/app/app.facade';
import { AuthFacade } from '../../store/state/auth/auth.facade';
import { filter, take } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import moment from 'moment';

@Pipe({
    name: 'toLocalTimezone',
    standalone: false
})
export class ToLocalTimezonePipe implements PipeTransform {
  private localeValue: string;
  private subscription: Subscription[] = [];
  private dateFormat: string;
  private timeFormat: string;

  constructor(private authFacade: AuthFacade, private cd: ChangeDetectorRef, private appFacade: AppFacade) {
    this.subscription.push(
      this.appFacade.currentLanguage$.pipe(filter(Boolean)).subscribe((language: Language) => {
        this.localeValue = LOCALE_CODE_LIST[language];
        this.cd.markForCheck();
      }),
      this.authFacade.isTwentyFourHourTime$.pipe(take(1)).subscribe((isTwentyFourHourTime: boolean) => {
        this.timeFormat = isTwentyFourHourTime ? TIME_SHORT_FORMAT : TIME_12HOUR_FORMAT;
        this.dateFormat = `${LOCALE_SHORT_DISPLAY_DATE_FORMAT} ${this.timeFormat} `;
      }),
    );
  }

  transform(
    timestamp: number,
    timezone: string,
    dateFormat: string = this.dateFormat,
    emptyPlaceholder: string = NOT_AVAILABLE,
  ): string {
    if (!timestamp) {
      return emptyPlaceholder;
    }

    const offset = getTimezoneOffsetInHours(timezone);

    return moment(getTimestampWithTimezoneOffset(timestamp, -offset)).locale(this.localeValue).format(dateFormat);
  }
}
